import type en from '../en/dashboard'
import type { Translation } from '../types'

/** The dashboard: the overview of all sites */
const dashboard: Translation<typeof en> = {
  "dashboard.greeting.morning": "Guten Morgen, {name}",
  "dashboard.greeting.afternoon": "Guten Tag, {name}",
  "dashboard.greeting.evening": "Guten Abend, {name}",
  "dashboard.subtitle": "Netzwerkübersicht über alle Ihre Standorte",
  "dashboard.totalSites": "Standorte gesamt",
  "dashboard.acrossAllSites": "An allen Standorten",
  "dashboard.connectedNow": "Jetzt verbunden",
  "dashboard.activeAlerts": "Aktive Warnungen",
  "dashboard.throughput": "Netzwerkdurchsatz",
  "dashboard.averageOver": "Durchschnitt über {period}",
  "dashboard.download": "↓ Download",
  "dashboard.upload": "↑ Upload",
  "dashboard.allSitesNote": "Alle Standorte zusammen. Den Verlauf je Standort finden Sie auf der Seite des Standorts.",
  "dashboard.recentAlerts": "Neueste Warnungen",
  "dashboard.allAlerts": "Alle Warnungen",
  "dashboard.noAlerts": "Keine aktiven Warnungen – alle Systeme in Ordnung",
  "dashboard.trafficSummary": "Datenverkehr im Überblick",
  "dashboard.totalReceived": "Insgesamt empfangen",
  "dashboard.totalSent": "Insgesamt gesendet",
  "dashboard.slowestSite": "LANGSAMSTER STANDORT",
  "dashboard.avg": "Ø {rate}",
}

export default dashboard
